<script>
  import { slide } from 'svelte/transition';
  export let note = '';
</script>

<div transition:slide={{ duration: 300 }}>
  <h2>{note}</h2>
  <button id="removeNote" on:click>🗑️</button>
</div>

<style>
  div {
    padding: 0 40px;
    margin: 20px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #3eb489;
    width: 35%;
    border-radius: 4px;
  }

  #removeNote {
    display: inline-flex;
    align-items: center;
    font-size: 1.2rem;
    width: auto;
    height: 2rem;
    background-color: rgba(255, 255, 255, 0.8);
    border: transparent;
    border-radius: 4px;
    cursor: pointer;
  }
</style>
